import RequestStatus from "../model/RequestStatus";
import {ProductInfo} from "src/model/ProductMatch";
import {BATCH_CALL_SIZE} from "src/model/TemplateUploadInputRecord";
import {ApiError} from "src/model/ApiError";

export const BULK_PRODUCTS_QUERY_START = 'BULK_PRODUCTS_QUERY_START';
export const BULK_PRODUCTS_QUERY_NOT_LOADED = 'BULK_PRODUCTS_QUERY_NOT_LOADED';
export const BULK_PRODUCTS_QUERY_SUCCESS = 'BULK_PRODUCTS_QUERY_SUCCESS';
export const BULK_PRODUCTS_QUERY_FAILED = 'BULK_PRODUCTS_QUERY_FAILED';

export interface BulkProductsReportQueryStartAction {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly countryCode: string;
    readonly products: Array<ProductInfo>;
    readonly batchSize: number;
    readonly locale: string;

}

export const setBulkProductsQueryStart = (countryCode: string, products: Array<ProductInfo>, locale: string): BulkProductsReportQueryStartAction => ({
    type: BULK_PRODUCTS_QUERY_START,
    requestStatus: RequestStatus.LOADING,
    countryCode: countryCode,
    products: products,
    batchSize: BATCH_CALL_SIZE,
    locale: locale,
});

export const setBulkProductsQueryClear = (): BulkProductsReportQueryStartAction => ({
    type: BULK_PRODUCTS_QUERY_NOT_LOADED,
    requestStatus: RequestStatus.NOT_LOADED,
    countryCode: "",
    products: [],
    batchSize: BATCH_CALL_SIZE,
    locale: ""
});

export interface GetBulkProductsQueryComplete {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly report: any;
    readonly countryCode: string | null;
    readonly error?: ApiError;
}

export const getBulkProductsQuerySuccessAction = (report: Array<Array<string>>, countryCode: string): GetBulkProductsQueryComplete => ({
    type: BULK_PRODUCTS_QUERY_SUCCESS,
    requestStatus: RequestStatus.SUCCESS,
    report: report,
    countryCode: countryCode,
});

export const getBulkProductsQueryFailedAction = (error?: ApiError): GetBulkProductsQueryComplete => ({
    type: BULK_PRODUCTS_QUERY_FAILED,
    requestStatus: RequestStatus.ERROR,
    report: null,
    countryCode: null,
    error: error
});
